import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const CalmMindsetSection = ({ heading, accentIndex = 0 }) => (
  <GuidePanel sectionId="a-calm-mindset" heading={heading} accentIndex={accentIndex}>
    <GuideCallout variant="amber">
      A calm mindset is not passive. It is the ability to remain composed while engaging with difficult
      situations.
    </GuideCallout>
    <p className="guide-panel__p">
      Composure is a practiced skill, not a temperament. It comes from a repeatable habit: pause before
      responding, separate what happened from what you assumed, and let evidence — not urgency — set the
      response. People who do this consistently are not less affected by pressure; they are simply less
      driven by it.
    </p>
    <GuideSectionLabel>People with a calm mindset</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="clarity" title="Welcome difficult conversations" description="Constructive, not avoidant" />
      <GuideCard iconKey="leader" title="Confident under pressure" description="Steady when stakes are high" />
      <GuideCard iconKey="energy" title="Thoughtful decisions" description="Deliberate, not impulsive" />
      <GuideCard iconKey="communication" title="Listen before responding" description="Curiosity over defensiveness" />
      <GuideCard iconKey="awareness" title="Stay curious" description="Questions instead of assumptions" />
      <GuideCard iconKey="leader" title="Build trust" description="Emotional steadiness others rely on" />
    </GuideCardGrid>
    <GuideCallout>
      Composure is not the absence of challenge—it is the ability to engage challenge with clear reasoning.
    </GuideCallout>
  </GuidePanel>
);

export default CalmMindsetSection;
